/**
 * @memberof module:compressed-json.converters
 * @namespace stringConverter
 */
'use strict';

import Prefixes from '../constants/Prefixes';
var PrefixValues = Object.values(Prefixes);
/** @lends module:compressed-json.converters.stringConverter */

var stringConverter = {
  toPointer: function toPointer(index) {
    return Prefixes.POINTER_PREFIX + index.toString(36);
  },
  toEscaped: function toEscaped(raw) {
    var needsEscape = PrefixValues.some(function (v) {
      return raw.startsWith(v);
    });
    return needsEscape ? Prefixes.ESCAPED_PREFIX + raw : raw;
  },
  fromEscaped: function fromEscaped(escaped) {
    var needsRestore = escaped.startsWith(Prefixes.ESCAPED_PREFIX);
    return needsRestore ? escaped.slice(Prefixes.ESCAPED_PREFIX.length) : escaped;
  },
  fromPointer: function fromPointer(pointer) {
    return pointer.slice(Prefixes.POINTER_PREFIX.length);
  },
  isPointer: function isPointer(value) {
    return value.startsWith(Prefixes.POINTER_PREFIX);
  }
};
export default stringConverter;